import { useContext } from 'react';
import { QueryFunctionContext, useQuery } from 'react-query';
import { parseUserKey, userKeys } from '../../cache-keys/userKeys';
import { heartbeat_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { queryFunction } from '../../query-function';

function heartbeatParams({
  queryKey,
}: QueryFunctionContext<ReturnType<(typeof userKeys)['heartbeat']>>) {
  const { user, country } = parseUserKey(queryKey);
  return {
    user,
    country,
  };
}

export function useHeartbeat(marketCountry?: string) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();

  return useQuery(
    userKeys.heartbeat({
      user: state.user.clientID,
      country: marketCountry ?? '',
    }),
    queryFunction(heartbeat_api.getHeartbeat(api), heartbeatParams),
    {
      enabled: marketCountry !== undefined,
    }
  );
}
